import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditVariable from "./Edit";
import {getValetContractInvoice, lineItemsUpdate} from "../../../../../../services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
    lineItems: state.postSalesReducer.lineItems,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetContractInvoice,
            lineItemsUpdate
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EditVariable);
